module.exports = __webpack_public_path__ + "img/change_password.35747f55.png";